import { Component, OnInit } from '@angular/core';

import { MainService } from 'app/resources/services/index';
import { DefineBootboxId } from 'app/resources/classes';

type Epwd = {atual: string, nova: string, confirmacao: string};

@Component({
  selector: 'app-epwd',
  templateUrl: './epwd.component.html',
  styleUrls: ['./epwd.component.css']
})
export class EpwdComponent implements OnInit {

  public mainService: MainService;
  public bootboxAlertComId: DefineBootboxId = new DefineBootboxId();
  public epwdIsNull: boolean;
  public epwd: Epwd;
  public processando: boolean;

  constructor(mainService: MainService) {
    this.mainService = mainService;
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.epwd = { atual: '', confirmacao: '', nova: '' };
    this.mainService.http.pathRest().get('cartao/current/epwdIsNull/', true)
      .subscribe(sucesso => {
        this.epwdIsNull = sucesso.json();
      });
  }

  public saveEPwd() {
    this.processando = true;
    this.mainService.http.pathRest().put('cartao/epwd/', this.epwd, true)
      .subscribe(sucesso => {
        this.epwdIsNull = false;
        this.processando = false;
        this.saveSuccess();
      }, erro => {
        this.processando = false;
        this.bootboxAlertComId.alerta(erro._body);
      });
  }

  private saveSuccess() {
    this.mainService.cartaoService.revalidar();

    if (this.epwdIsNull) {
      this.mainService.loginService.changeRoute('/cartao/epwd');

    } else if (!this.epwdIsNull) {
      this.mainService.loginService.changeRoute('/home');
    }

    this.bootboxAlertComId.alerta('Informações salvas com sucesso!');
  };
}



// WEBPACK FOOTER //
// ./src/app/menu-superior/meu-cadastro/epwd/epwd.component.ts